

















































import Vue from 'vue'
import { getModule } from 'vuex-module-decorators'
import Component from 'vue-class-component'
import SearchInput from '@/components/inputs/SearchInput.vue'
import DateInput from '@/components/inputs/DateInput.vue'
import Select from '@/components/Select.vue'
import Icon from '@/components/Icon.vue'
import { PaymentsModule } from '@/store/modules/payments.module'
import { ResidentModule } from '@/store/modules/resident.module'
import {
  EPaymentStatus,
  IPaymentsFiltersDTO,
  EUserPermissions
} from '@zunta/configurations'
import { getPaidByLabel, formatTransactionEffectiveDate } from '@/utils/helpers'
import DateTimeLabel from '@/components/labels/DateTimeLabel.vue'
import ResidentLabel from '@/components/labels/ResidentLabel.vue'
import Card from '@/components/Card.vue'
import { User } from '@/classes/User'
import Api from '@/api'
import Table from '@/components/tables/Table.vue'
import { ETableColumnType, ITableConfig } from '@/interfaces'
import StatusPayment from '@/components/statuses/StatusPayment.vue'
import { PAYMENT_STATUSES_LABEL_MAP } from '@/constants'
import { downloadFile } from '@/utils/fileHelper'
import ButtonDownloadReport from '@/components/ButtonDownloadReport.vue'

@Component({
  components: {
    ButtonDownloadReport,
    StatusPayment,
    Table,
    Card,
    ResidentLabel,
    Select,
    SearchInput,
    DateInput,
    Icon,
    DateTimeLabel
  }
})
export default class PaymentsProcessed extends Vue {
  paymentsModuleInstance: PaymentsModule = getModule(PaymentsModule, this.$store)
  residentModuleInstance: ResidentModule = getModule(ResidentModule, this.$store)
  formatTransactionEffectiveDate: Function = formatTransactionEffectiveDate
  getPaidByLabel: Function = getPaidByLabel

  EUserPermissions: any = EUserPermissions
  EPaymentStatus: any = EPaymentStatus
  user: User = Api.getUser() as User
  filters: IPaymentsFiltersDTO = {
    skip: 0,
    limit: 20,
    isBilling: true
  }

  config: ITableConfig = {
    clearFilterBtn: {
      wrapperClass: 'position-absolute',
      wrapperStyle: 'top: -1.5rem; right: -1.5rem;',
      class: 'rounded-top-bottom'
    },
    useQuery: true,
    usePagination: true,
    useSubrow: true,
    fetchFunction: this.paymentsModuleInstance.getPaymentsList,
    columns: [
      {
        minWidth: '100px',
        width: 6,
        key: 'willowPaymentId',
        searchKey: 'willowPaymentId',
        label: 'Id',
        hasSort: true,
        hasSearch: true,
        type: ETableColumnType.default
      },
      {
        minWidth: '250px',
        width: 41,
        key: 'facility',
        searchKey: 'facility',
        label: 'Facility',
        hasSort: true,
        hasSearch: true,
        type: ETableColumnType.default
      },
      {
        headClass: 'bt-justify-content-end',
        class: 'text-right',
        minWidth: '150px',
        width: 20,
        key: 'amountPaid',
        searchKey: 'amountPaid',
        label: 'Amount',
        hasSort: true,
        hasSearch: true,
        type: ETableColumnType.numberRange
      },
      {
        minWidth: '150px',
        width: 20,
        key: 'paidDate',
        searchKey: 'paidDate',
        label: 'Date',
        hasSort: true,
        hasSearch: true,
        type: ETableColumnType.dateRange
      },
      {
        minWidth: '130px',
        width: 13,
        key: 'status',
        searchKey: 'status',
        label: 'Status',
        hasSort: true,
        hasSearch: true,
        type: ETableColumnType.multiselect,
        options: this.allowedStatuses
      }
    ]
  }

  get paymentsList () {
    return this.$store.state.payments.paymentStatusList
  }

  get recordsTotal () {
    return this.$store.state.payments.total
  }

  getLocaleDate (date: any) {
    // @ts-ignore
    return new Date(date).toLocaleString('en-US', { dateStyle: 'short', timeStyle: 'short' })
  }

  get allowedStatuses () {
    return Object.values(EPaymentStatus).map((status: string) => ({
      content: PAYMENT_STATUSES_LABEL_MAP[status],
      key: status,
      value: status
    }))
  }
}
